import { render, staticRenderFns } from "./glExplain.vue?vue&type=template&id=554da386&scoped=true"
import script from "./glExplain.vue?vue&type=script&lang=js"
export * from "./glExplain.vue?vue&type=script&lang=js"
import style0 from "./glExplain.vue?vue&type=style&index=0&id=554da386&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554da386",
  null
  
)

export default component.exports